import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import ValuePropositions from './components/ValuePropositions';
import EquipmentGrid from './components/EquipmentGrid';
import WhyChooseUs from './components/WhyChooseUs';
import PricingSection from './components/PricingSection';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import QuoteRequestModal from './components/QuoteRequestModal';
import AboutUs from './pages/AboutUs';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import EquipmentLanding from './pages/EquipmentLanding';
import EquipmentCategory from './pages/EquipmentCategory';
import EquipmentDetail from './pages/EquipmentDetail';
import './App.css';

function App() {
  const [quoteModalOpen, setQuoteModalOpen] = useState(false);

  const handleOpenQuoteModal = () => {
    setQuoteModalOpen(true);
  };

  const handleCloseQuoteModal = () => {
    setQuoteModalOpen(false);
  };

  const HomePage = () => (
    <>
      <Hero onQuoteClick={handleOpenQuoteModal} />
      <ValuePropositions onQuoteClick={handleOpenQuoteModal} />
      <EquipmentGrid onQuoteClick={handleOpenQuoteModal} />
      <WhyChooseUs />
      <PricingSection />
      <Testimonials />
    </>
  );

  return (
    <BrowserRouter>
      <div className="App">
        <Toaster position="top-right" />
        <Header onQuoteClick={handleOpenQuoteModal} />
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/equipment" element={<EquipmentLanding onQuoteClick={handleOpenQuoteModal} />} />
          <Route path="/equipment/:id" element={<EquipmentDetail onQuoteClick={handleOpenQuoteModal} />} />
          <Route path="/about" element={<AboutUs onQuoteClick={handleOpenQuoteModal} />} />
          <Route path="/contact" element={<Contact onQuoteClick={handleOpenQuoteModal} />} />
          <Route path="/faq" element={<FAQ onQuoteClick={handleOpenQuoteModal} />} />
        </Routes>

        <Footer onQuoteClick={handleOpenQuoteModal} />
        <QuoteRequestModal isOpen={quoteModalOpen} onClose={handleCloseQuoteModal} />
      </div>
    </BrowserRouter>
  );
}

export default App;
